import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import AnalyticsHubReport from "../../components/power-bi/AnalyticsHubReport";
import { AnalyticsHubContext } from "../../contexts/AnalyticsHubContext";
import "./analyticsHub.scss";

const AnalyticsHubPage = () => {
  const { setPages } = useContext(AnalyticsHubContext);
  const { pageName } = useParams();

  // Convert kebab-case URL parameter to display name
  // e.g., "alignment-score" -> "Alignment Score"
  const displayName = pageName
    ? pageName
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "Summary";

  return (
    <div className="analytics-hub-page">
      <AnalyticsHubReport pageName={displayName} onPagesLoaded={setPages} />
    </div>
  );
};

export default AnalyticsHubPage;
